




import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
  components: {},
})
export default class HotKeyListener extends Vue {

  @Prop(Boolean) public disabled!: boolean;

  private keyUpListener!: (event: KeyboardEvent) => void;
  private keyDownListener!: (event: KeyboardEvent) => void;

  private created() {
    this.keyUpListener = this.keyUp.bind(this);
    this.keyDownListener = this.keyDown.bind(this);
    window.addEventListener('keyup', this.keyUpListener);
    window.addEventListener('keydown', this.keyDownListener);
  }

  private beforeDestroy() {
    window.removeEventListener('keyup', this.keyUpListener);
    window.removeEventListener('keydown', this.keyDownListener);
  }

  private keyUp(event: KeyboardEvent) {
    if (!this.disabled) {
      this.$emit('hotkeyUpEvent', event);
    }
  }

  private keyDown(event: KeyboardEvent) {
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp' || event.key === 'PageDown' || event.key === 'PageUp') {
      event.preventDefault();
    }
    if (!this.disabled) {
      this.$emit('hotkeyDownEvent', event);
    }
  }

}
